import { DocumentationInterface } from "../domain/documentation.interface";
import { DirectusAvailableLanguages } from "../../types/directus.types";
import { DirectusService } from "../../directus.service";
import { ApiUtils } from "@/modules/api/Api.utils";
import { DirectusEntityPayload } from "../../termsAndConditions/types/termsAndConditions.types";
import { fetchWrapper } from "@chatsystem/common/utils";

export class DocumentationsRepository implements DocumentationInterface {
  async get(lang: DirectusAvailableLanguages): Promise<DirectusEntityPayload> {
    "use server";
    const query = DirectusService.buildEntityQuery(
      "documentation_translations"
    );
    const urlComplete = DirectusService.addLanguageToQuery(query, lang);

    const fetchConfig = ApiUtils.getFetchConfig({});

    const resp = await fetchWrapper(urlComplete, fetchConfig);

    const documentation = await (resp as Response).json();

    return documentation as DirectusEntityPayload;
  }
}
